const localesBySite = new Map();
localesBySite.set('IWBR', {
  locale: 'pt-BR',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: 'R$'
  }
});
localesBySite.set('WIBR', {
  locale: 'pt-BR',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: 'R$'
  }
});
localesBySite.set('CMBR', {
  locale: 'pt-BR',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: 'R$'
  }
});
localesBySite.set('ICBR', {
  locale: 'pt-BR',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: 'R$'
  }
});
localesBySite.set('ZPAR', {
  locale: 'es-AR',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: '$'
  }
});
localesBySite.set('24MX', {
  locale: 'es-MX',
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: 'MN'
  }
});
localesBySite.set('DVPE', {
  locale: 'es-PE',
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: 'S/'
  }
});
localesBySite.set('LLVE', {
  locale: 'es-VE',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: 'BsS'
  }
});
localesBySite.set('PLEC', {
  locale: 'es-EC',
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  currency: {
    symbol: 'USD'
  }
});
localesBySite.set('CAPA', {
  locale: 'es-PA',
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: 'USD'
  }
});
localesBySite.set('UBPE', {
  locale: 'es-PE',
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: 'S/'
  }
});

export default localesBySite;
